__turbopack_context__.v({
  "button": "XXlj9W_button",
  "link": "XXlj9W_link",
});
